import type {AxiosError} from 'axios';
import {useMutation, useQueryClient, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {updateCitizenship, type UpdateCitizenshipRequest, type UpdateCitizenshipResponse} from '../../http';

export function useUpdateCitizenship(
	options?: UseMutationOptions<UpdateCitizenshipResponse, AxiosError, UpdateCitizenshipRequest>,
): UseMutationResult<UpdateCitizenshipResponse, AxiosError, UpdateCitizenshipRequest> {
	const queryClient = useQueryClient();

	return useMutation<UpdateCitizenshipResponse, AxiosError, UpdateCitizenshipRequest>(
		(request) => updateCitizenship(request).then(({data}) => data),
		{
			...options,
			onSuccess: (data, variables, context) => {
				queryClient.invalidateQueries({queryKey: ['identification', 'info']});
				options?.onSuccess?.(data, variables, context);
			},
		},
	);
}
